import { mapFormSchema, type MapForm } from "@/schemas/map/mapFormSchema";
import { formOptions, revalidateLogic } from "@tanstack/react-form";

export const defaultValues: MapForm = {
  zoom: 8,
  darkMapUrl:
    "https://api.maptiler.com/maps/019c8f0e-28e7-7e83-925d-a6ad1dc5faea/style.json?key=4e4hubZ4ZDnLtrrg5ekB",
  lightMapUrl:
    "https://api.maptiler.com/maps/019c93f0-03d3-7b44-93c3-66aa3be21222/style.json?key=4e4hubZ4ZDnLtrrg5ekB",
  satelliteMapUrl:
    "https://api.maptiler.com/maps/hybrid-v4/style.json?key=4e4hubZ4ZDnLtrrg5ekB",
  showSatellite: false,
  position: {
    longitude: -0.793210148752871,
    latitude: 50.8684884219472,
  },
};

export const mapFormOptions = formOptions({
  defaultValues,
  validators: {
    onSubmit: mapFormSchema,
  },
  validationLogic: revalidateLogic({
    mode: "submit",
    modeAfterSubmission: "change",
  }),
});
